import { useEffect, useRef, useState } from 'react'

const POLL_INTERVAL_MS = 60_000
const VERSION_URL = '/version.json'

async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: 'no-store' })
    if (!res.ok) return null
    const data = await res.json()
    return typeof data.version === 'string' ? data.version : null
  } catch {
    return null
  }
}

export function useUpdateCheck(): boolean {
  const [updateAvailable, setUpdateAvailable] = useState(false)
  const currentVersion = useRef<string | null>(null)

  useEffect(() => {
    let cancelled = false

    fetchVersion().then(version => {
      if (!cancelled) currentVersion.current = version
    })

    const interval = setInterval(async () => {
      const version = await fetchVersion()
      if (!cancelled && version && currentVersion.current && version !== currentVersion.current) {
        setUpdateAvailable(true)
      }
    }, POLL_INTERVAL_MS)

    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [])

  return updateAvailable
}
